export default {
      id: "md_offline-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "img/icons.svg#md_offline",
      toString: function () {
        return this.url;
      }
    }